export default __webpack_public_path__ + "static/media/ELEMENTOS_19.48c288c1.png";